import { FC } from "react";

type InputRadioProps = {
  id: string;
  name?: string;
  value?: string;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const InputRadio: FC<InputRadioProps> = ({
  id,
  name,
  value,
  onChange,
  checked,
}) => {
  return (
    <input
      checked={checked}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      type="radio"
      aria-describedby={id}
      className="h-4 w-4 border-gray-300 text-primary-500 focus:ring-primary-500"
    />
  );
};

export default InputRadio;
